import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class GamepadErrorBoundary extends Component<Props, State> {
  public override state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Gamepad error:', error);
    console.error('Error info:', errorInfo);
  }

  public override render() {
    if (this.state.hasError) {
      return (
        <div className='rounded-md bg-red-500/10 p-4 text-red-500'>
          <h2 className='mb-2 font-bold'>Something went wrong with the gamepad</h2>
          <p className='text-sm'>{this.state.error?.message}</p>
        </div>
      );
    }

    return this.props.children;
  }
}

